<template>
    <div class="
            d-flex
            align-items-center
            p-4
            
            me-5
            text-white
            saudacao
        ">

        <div class="lh-1">

            <strong>Olá {{ usuario?.nome }}!</strong><br />
            <small>
                {{ usuario?.email }}
            </small>
        </div>
    </div>
</template>
<script lang="ts" setup>
//import Logo from '@/assets/logo.svg?component'
import { current_user as usuario } from '@/store/auth';

</script>
<style lang="less" scoped>
svg.logo {
    font-size: 2rem;
    color: white;
}
.saudacao {
    background-color: #0F61B2;
    padding-right: 8em!important;
}
</style>
